import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Select, AutoComplete, Form
} from 'antd';
import {
  isNaN, isInteger,
} from 'lodash';
import TextArea from 'antd/lib/input/TextArea';
import FormModal from '../../../../common/FormModalSurgery';
//import UploadComponent from '../../../../common/UploadComponent';
import { getAllMedicalSurgeryAutoComplete } from '../../../../store/actions';

//const { Option } = Select;
const { Option } = Select;

let setTestId, setSurgeryCategoryId;

const CatalogLabFormModal = ({ data = {}, getAllSurgeries, ...props }) => {
  const [result, setResult] = useState([]);
  const [testname, setTestname] = useState(0);
  const [form] = Form.useForm();

  const hdnTestId = getAllSurgeries && getAllSurgeries.filter(v => v.name === testname);

  if (hdnTestId === undefined || hdnTestId === null || hdnTestId == "") {
    setTestId = '';
    setSurgeryCategoryId = '';
  } else {
    setTestId = hdnTestId[0].surgery_id;
    setSurgeryCategoryId = hdnTestId[0].surgery_category_id;
  }

  const handleChange = (e) => {
    setTestname(e);
  }

  const handleSearch = (value) => {
    let res = [];
    props.getAllMedicalSurgeryAutoComplete(value);
    setResult(res);
  };

  if (setTestId && setTestId) {
    data.vendor_health_centre_surgery_id = setTestId;
  } else {
    data.vendor_health_centre_surgery_id = '';
  }

  if (setSurgeryCategoryId && setSurgeryCategoryId) {
    data.vendor_health_centre_surgery_category_id = setSurgeryCategoryId;
  } else {
    data.vendor_health_centre_surgery_category_id = '';
  }

  return (
    <FormModal
      {...props}
      data={data}
      formItems={[
        {
          key: 'name',
          label: 'Surgery Name',
          width:16,
          rules: [{ required: true, message: 'Please input Surgery name!' }],
          Component: (
            <Select
              // style={{
              //   width: 400,
              // }}
              showSearch
              size='large'
              onSearch={handleSearch}
              disabled={props.title.split(" ")[0] === 'Edit'}
              onChange={value => handleChange(value)}
              placeholder="Search Surgery Name"
            >
              {getAllSurgeries && getAllSurgeries.map((data) => (
                <Option key={data.surgery_id} value={data.name}>
                  {data.name}
                </Option>
              ))}
            </Select>
          ),
        },
        {
          key: 'status',
          label: 'Status',
          rules: [{ required: true, message: 'Please Test Status!' }],
          width:8,
          Component: (
            <Select
            size='large'>
              <Option value>Active</Option>
              <Option value={false}>Blocked</Option>
            </Select>
          ),
        },
        {
          key: 'consultation_cost',
          label: 'Consultation cost',
          width:8,
          rules: [{ required: true, message: 'Please input Consultation cost!' },
          () => ({
            validator(rule, value) {
              if (isNaN(Number(value))) {
                return Promise.reject('Not a valid Number');
              }
              if (value && Number(value) <= 0) {
                return Promise.reject('Consultation cost cannot be less than 1!');
              }
              if (value && !isInteger(Number(value))) {
                return Promise.reject('Consultation has to be a whole number!');
              }
              if (Number(value) > 5000) {
                return Promise.reject('Cannot be more than 5000');
              }
              return Promise.resolve();
            },
          }),
          ],
        },
        {
          key: 'diagnostics_cost',
          label: 'Diagnostic cost',
          width:8,
          // rules: [{ required: true, message: 'Please input Diagnostic cost!' }],
          rules: [{ required: true, message: 'Please input Diagnostic cost!' },
          {
            pattern: new RegExp(/^[ 0-9,-]*$/),
            message: "Field does not accept Special Characters or Alphabets"
          },
          () => ({
            validator(rule, value) {
              // if (isNaN(Number(value))) {
              //   return Promise.reject('Not a valid Number');
              // }
              // if (value && Number(value) <= 99) {
              //   return Promise.reject('Consultation cost cannot be less than 100!');
              // }
              // if (value && !isInteger(Number(value))) {
              //   return Promise.reject('Consultation has to be a whole number!');
              // }
              // if (Number(value) > 1500) {
              //   return Promise.reject('Cannot be more than Thousand Five Hundred');
              // }
              return Promise.resolve();
            },
          }),
          ],
        },
        {
          key: 'surgery_cost',
          label: 'Surgery cost',
          width:8,
          // rules: [{ required: true, message: 'Please input Surgery cost!' }],
          rules: [{ required: true, message: 'Please input Surgery cost!' },
          {
            pattern: new RegExp(/^[ 0-9,-]*$/),
            message: "Field does not accept Special Characters or Alphabets"
          },
          () => ({
            validator(rule, value) {
              // if (isNaN(Number(value))) {
              //   return Promise.reject('Not a valid Number');
              // }
              // if (value && Number(value) <= 99) {
              //   return Promise.reject('Surgery cost cannot be less than 100!');
              // }
              return Promise.resolve();
            },
          }),
          ],
        },
        {
          key: 'estimated_total',
          label: 'Estimated Total',
          width:8,
          // rules: [{ required: true, message: 'Please input Estimated Total!' }],
          rules: [{ required: true, message: 'Please input Estimated cost!' },
          {
            pattern: new RegExp(/^[ 0-9,-]*$/),
            message: "Field does not accept Special Characters or Alphabets"
          },
          () => ({
            validator(rule, value) {
              // if (isNaN(Number(value))) {
              //   return Promise.reject('Not a valid Number');
              // }
              // if (value && Number(value) <= 99) {
              //   return Promise.reject('Estimated cost cannot be less than 100!');
              // }
              return Promise.resolve();
            },
          }),
          ],
        },
        {
          key: 'package_includes',
          label: 'Package Includes',
          width:8,
          Component: (
            <TextArea />
          ),
        },
        {
          key: 'package_excludes',
          label: 'Package Excludes',
          width:8,
          Component: (
            <TextArea />
          ),
        },
        {
          key: 'surgery_id',
          hidden: true,
          width:8,
        },
        {
          key: 'surgery_category_id',
          hidden: true,
          width:8,
        },
      ]}
    />
  )
};
//export default CatalogLabFormModal;

const mapStateToProps = ({ medicalReducer = {} }) =>
({
  results: medicalReducer.results,
  getAllSurgeries: medicalReducer.getAllSurgeries,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAllMedicalSurgeryAutoComplete,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(CatalogLabFormModal);
